module.exports = __webpack_public_path__ + "media/images/aloe/icons/bank-004c457ca1d8ec3d6793de80bf39a9c4.svg";